// 虚拟条码申请单-主页
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :processId="processId" :_dataId.sync="dataId" :type="type" :parent-target="_self"
                  @reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate" @changeTab="changeTab"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div>
          <vxe-grid :stripe="true" border="default" show-overflow :row-config="{ isHover: true }"
                    ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns" style=" border-bottom: 1px solid #ededed !important;">
                <div class="fl">
                  <vxe-button v-if="addButton" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog(0, 'add')">新增
                  </vxe-button>
                  <vxe-button v-if="exportButton" status="primary" class="button-sty" icon="el-icon-top"
                              @click="doExcle">导出
                  </vxe-button>
                  <vxe-button v-if="cancleButton" status="primary" class="button-sty" icon="el-icon-top"
                              @click="batchCancleBill">批量取消
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;position: relative;">
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;" class="button-sty"
                              @click="searchEvent">{{ $t('common.search') }}
                  </vxe-button>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form  ref="form" class="screen-box" title-width="92px"
                          title-align="right" :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                  <vxe-form-item title="申请单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.billNo" size="small" clearable>

                      </el-input>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="工单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.orderNo" size="small" clearable>

                      </el-input>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="条码:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.barcode" size="small" clearable>

                      </el-input>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="条码异常情况:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.exceptionBarcodeName" style="width:9vw ;" clearable>
                        <!--                        <el-option :value="null" label="全部"></el-option>-->
                        <el-option value="不在条码库" label="不在条码库"></el-option>
                        <el-option value="条码被占用" label="条码被占用"></el-option>
                        <el-option value="重复维修" label="重复维修"></el-option>
                        <el-option value="条码出现多个地区" label="条码出现多个地区"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="虚拟条码:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.virtualBarcode" size="small" clearable>
                      </el-input>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="状态:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.stat" :disabled="requestParam.stat"  style="width:9vw ;" clearable>
                        <el-option :value="null" label="全部"></el-option>
                        <el-option :value="1" label="制单"></el-option>
                        <el-option :value="2" label="审核中"></el-option>
                        <el-option :value="5" label="已审核"></el-option>
                        <el-option :value="6" label="驳回"></el-option>
                        <el-option :value="99" label="取消"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="创建时间:" field="name">
                    <template v-slot>
                      <el-date-picker
                      style="width: 17vw;"
                       v-model="formData.createDate" type="daterange" align="right" unlink-panels
                                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="流程开始时间:" field="name">
                    <template v-slot>
                      <el-date-picker
                        style="width: 17vw;"
                        v-model="formData.checkTime" type="daterange" align="right" unlink-panels
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
                    btnGoodsStatusBt1: goodsStatusIndex == index,
                    btnGoodsStatusBt: goodsStatusIndex != index
                  }" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span class="num_color" v-if="item.name !== '所有'">{{ item.num }}</span>
                  </div>
                </div>
              </div>
            </template>

            <template #option="{row}">
              <div>
                <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row, 'edit')">
                  <el-tooltip :enterable=false effect="dark" content="编辑" placement="top"
                              popper-class="tooltip-skin">
                    <i class="el-icon-edit"/>
                  </el-tooltip>
                </a>
                <el-dropdown @command="handleCommand($event, row)">
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a" v-if="(row.stat == 1)&&submitButton && !row.processId">提交</el-dropdown-item>
                    <el-dropdown-item command="b" v-if="row.stat == 2&&checkButton && !row.processId">审核</el-dropdown-item>
                    <el-dropdown-item command="c" v-if="row.stat == 2&&rejectButton && !row.processId">驳回</el-dropdown-item>
                    <el-dropdown-item command="d" v-if="(row.stat == 1||row.stat == 6)&&cancelButton && !row.processId">取消</el-dropdown-item>
                    <el-dropdown-item command="e" v-if="row.stat == 1 && !row.processId">启动流程</el-dropdown-item>
                    <el-dropdown-item command="f" v-if="row.processId!=null">查看流程</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{dialogMsg}}</span>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>

    <el-dialog
      :visible.sync="showPicDialog"
      title="流程图">
      <img v-if="showPicDialog" :src="actPicUrl" width="100%">
    </el-dialog>

  </div>
</template>

<script>
import editView from './edit.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import closeDialog from "./closeDialog.vue";
import confirmDialog from "./confirmDialog.vue";
import auditDialog from './auditDialog.vue'
import request from "@/router/axios";
import checkboxButton from "element-ui/packages/checkbox-button";
import api from "@/api/projectApi";
import store from "@/store";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";


export default {
  name: 'barcodeApplication',

  inject: ['reload'],
  components:
  {editView, pager, closeDialog, confirmDialog, auditDialog},
  data() {
    return {
      exportButton:  false,
      cancleButton: false,
      processDefinitionId:null,
      loading: false,
      actPicUrl:"",
      showPicDialog:false,
      type: null, // 打开常规页面类型
      drawer: false,
      total: 0,
      checkBillId: null,
      confirmNo: null,
      formLabelWidth:'80px',
      checkSubjectOption: [],
      initiateAppeal:false,
      isSite:null,
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        stat: 1,
        searchValueIsEnable: false,
        billNo: '',  //申请单号;前缀"VB"+年月日+6位流水号
        orderNo: '',
        createTimeBegin: null,
        createTimeEnd: null,
        searchValue: '',
        barcode: '',
        virtualBarcode: '',
        exceptionBarcodeName:'',
        checkTimeBegin: null,
        checkTimeEnd: null
      },
      formData: {
        createDate: null,
        checkTime:null,
        billNo: '',  //申请单号;前缀"VB"+年月日+6位流水号
        stat: 1,  // 状态：1制单；2.待确认；3待申诉；5已申诉；7执行考核；9已结算；19取消执行；99关闭
        orderNo: '',
        searchValue: '',
        barcode: '',
        virtualBarcode: '',
        exceptionBarcodeName:'',
        createTimeBegin: null,
        createTimeEnd: null,
        checkTimeBegin: null,
        checkTimeEnd: null
      },
      form2: {
        appealRemark: '',
        siteAnswerNote:'',
      },

      editViewDataUpdateFlag: false,
      showSelectStat: false,

      goodsStatusList: [],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个
      show3: false,

      showCloseDialog: false,
      showConfirmDialog: false,
      showAuditDialog: false,

      showPreconditionDialog: false,
      showPreconditionDialog2: false,
      dialogVisible: false,

      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      value2: '',
      value3: '',
      value: '',
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      fileList:[],


      pageSizes: [10, 20, 100],
      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        { width: 100, field: 'stat', fixed: 'right', title: '操作', showOverflow: true, slots: { default: 'option' }},
        {title: '申请单号', field: 'billNo', width: 190, slots: {
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.showInfo(row, $event)}>{row.billNo}</span>
              ]
            }
          }},
        {
          title: '状态', field: 'stat', width: 125, slots: {
            default: ({row}) => {
              if (row.stat == 1) {
                return [
                  <div class="txt-status">
                    <span>制单</span>
                  </div>
                ];
              } else if (row.stat == 2) {
                return [
                  <div class="txt-status neutral">
                    <span>审核中</span>
                  </div>
                ];
              } else if (row.stat == 5) {
                return [
                  <div class="txt-status">
                    <span>已审核</span>
                  </div>
                ];
              } else if (row.stat == 6) {
                return [
                  <div class="txt-status">
                    <span>驳回</span>
                  </div>
                ];
              } else if (row.stat == 99) {
                return [
                  <div class="txt-status disable">
                    <span>取消</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '服务中心', field: 'orgName', width: 100,},
        {title: '服务商名称', field: 'siteName', width: 100,},
        {title: '联系电话', field: 'siteMobile', width: 100,},
        {title: '服务类型', field: 'serviceTypeName', width: 100,},
        {title: '工单号', field: 'orderNo', width: 190,},
        {title: '条码', field: 'barcode', width: 100,},
        {title: '流程发起时间', field: 'flowTime', width: 100,},
        {title: '创建人', field: 'createBy', width: 100,},
        {title: '创建时间', field: 'createTime', width: 100,},
      ]
    };
  },
  watch: {
    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },

    'formData.checkTime': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.checkTimeBegin = newVal[0]
          this.formData.checkTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.checkTimeBegin = null
          this.formData.checkTimeEnd = null
        }
      },
      deep: true,
    },

    showPreconditionDialog(newVal) {
      if (!newVal) {
        this.reload()
      }
    },

    editViewDataUpdateFlag(n) {
      if (n) {
        this.editViewDataUpdateFlag = false
        this.flushed()
      }
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.flushed()
      }
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },

  computed: {
    checkboxButton() {
      return checkboxButton
    },
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    },
    ...mapGetters(["permissions"]),

  },
  created() {
    this.addButton = this.permissions["wkVirtualBarcodeBillAdd"];
    this.exportButton = this.permissions["wkVirtualBarcodeBillExport"];
    this.cancleButton = this.permissions["wkVirtualBarcodeBillCancel"];
    this.editButton = this.permissions["wkVirtualBarcodeBillEdit"];
    this.submitButton= this.permissions["wkVirtualBarcodeBillSubmit"]; //提交
    this.checkButton= this.permissions["wkVirtualBarcodeBillCheck"]; //审核
    this.rejectButton= this.permissions["wkVirtualBarcodeBillReject"]; //驳回
    this.cancelButton= this.permissions["wkVirtualBarcodeBillCancel"]; //取消
    this.recallButton= this.permissions["wkVirtualBarcodeBillRecall"]; //回访
    const userInfo = store.getters.userInfo;
    if (userInfo.snUserId){
      this.isSite = true;
    }
    console.log(this.checkButton, "this.checkButton");
  },
  mounted() {
    this.loadTabOption()
    this.initDate()
  },
  methods: {
    doExcle() {
      // const  result =
      this.$mask.open()
      this.$objCopy(this.formData, this.requestParam)
      doCheckExcle(fileNames.exceptionBarcode).then(response => {
        if (response.data.msg == "success") {
          doDownLoadExcle(api.wkVirtualBarcodeBill.exportUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
        } else {
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },
		toFilterData() {
            this.searchEvent();
     },
    confirm() {
      this.$mask.open()

      this.$http({
        url: api.wkVirtualBarcodeBill.confirmDataUrl,
        method: 'post',
        data: {
          id: this.currentRow.id,
          statName: this.statName
        }
      }).then(res => {
        this.$message.success('操作成功')
        this.flushed()
      })
      this.dialogVisible = false
      this.$mask.close()

    },

    flushed() {
      this.loadTabOption()
      this.$refs['table-m1'].commitProxy('reload');
    },
    // 切换tab到列表页
    changeTab() {
      this.activeName = 'second';
      this.showEdit = false
      this.flushed()
    },

    // 显示详情
    showInfo(row, $event) {
      this.openEditDialog(row, 'info')
    },

    //抽屉关闭后改变父组件的visible的值
    closeD(v) {
      this.showConfirmDialog = false
      this.showCloseDialog = false
      this.showAuditDialog = false
      // this.flushed()
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.requestParam.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },

    handleSuccess2(res, file, fileList) {
      this.fileList.push(res.data.url)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },

    // 设置搜索时间条件默认一个月内
    initDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.formData.createDate = [start, end]
      this.requestParam.createTimeBegin = start
      this.requestParam.createTimeEnd = end
    },

    // 加载tab数据
    loadTabOption() {
      this.$http({
        url: api.wkVirtualBarcodeBill.getCountUrl,
        method: 'post',
        data: this.requestParam
      }).then(res => {
        console.log("tab数据",res.data.data)
        this.goodsStatusList = res.data.data
        this.goodsStatusList.forEach((item,index) =>{
          if(item.num === null){
            item.num = 0
          }
        })
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比
      let s = null
      if (item.name === '制单') {
        s = 1
      } else if (item.name === '审核中') {
        s = 2
      } else if (item.name === '驳回') {
        s = 6
      } else if (item.name === '取消') {
        s = 99
      }
      this.requestParam.stat = s
      this.formData.stat = s
      this.flushed()
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true
    },

    cancelForm() {
      this.loading = false;
      this.initiateAppeal = false;
      clearTimeout(this.timer);
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.wkVirtualBarcodeBill.getTableDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      let formData = this.formData
      this.requestParam.createTimeBegin = formData.createTimeBegin
      this.requestParam.createTimeEnd = formData.createTimeEnd
      this.requestParam.checkTimeBegin = formData.checkTimeBegin
      this.requestParam.checkTimeEnd = formData.checkTimeEnd
      this.requestParam.billNo = this.formData.billNo
      this.requestParam.orderNo = this.formData.orderNo
      this.requestParam.siteName = this.formData.siteName
      this.requestParam.stat = this.formData.stat
      this.requestParam.barcode = this.formData.barcode
      this.requestParam.virtualBarcode = this.formData.virtualBarcode
      this.requestParam.exceptionBarcodeName = this.formData.exceptionBarcodeName
      this.requestParam.searchValue = this.formData.searchValue
      this.requestParam.searchValueIsEnable = false
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    async toInitiateAppeal() {
      try {
        this.loading = true;
        // 发送请求
        const res = await axios.post(api.sfCheckBill.siteAppeal, {
          id: this.dataId,
          siteAnswerNote: this.form2.siteAnswerNote,
          piclist: this.fileList,
          checkType: 1
        });
        if (res.data) {
          // 确保 el-drawer 组件已经初始化完成再关闭该窗口
          // this.$nextTick(() => {
          //   this.$refs.drawer.closeDrawer();
          // });
          this.$message.success('操作成功！');
          this.fileList = [];
          this.form2.siteAnswerNote = '';
          this.cancelForm()
          this.flushed()
        } else {
          this.$message.error('操作失败，请稍后重试');
        }
      } catch (error) {
        console.error(error);
        this.$message.error('系统错误，请稍后重试');
      } finally {
        this.loading = false;
      }
    },

    //批量取消单据
    batchCancleBill() {
      let orderIds = [];
      const checkIds = this.$refs['table-m1'].getCheckboxRecords();
      if (checkIds.length == 0) {
        this.$message.error('请先选择需要取消的单据！')
        return
      }
      for (let i = 0; i < checkIds.length; i++) {
        orderIds.push(checkIds[i].id)
      }
      this.$confirm('是否确认全部取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$mask.open()
        this.$http({
          url: api.wkVirtualBarcodeBill.batchCancleUrl,
          method: 'post',
          data: {
            orderIds: orderIds
          },
        }).then(res => {
          this.$mask.close()
          if (res.data.type) {
            this.$message.success('操作成功')
            this.flushed()// 需要刷新页面
          }
        }).catch(() => {
        this.$mask.close()
      });
      }).catch(() => {
        this.$mask.close()
      });
      this.$mask.close()
    },

    async cancleAppeal() {
      try {
        this.loading = true;
        // 发送请求
        const res = await axios.post(api.sfCheckBill.siteAppeal, {
          id: this.dataId,
          siteAnswerNote: this.form2.siteAnswerNote,
          piclist: this.fileList,
          checkType: 0
        });
        if (res.data) {
          // 确保 el-drawer 组件已经初始化完成再关闭该窗口
          // this.$nextTick(() => {
          //   this.$refs.drawer.closeDrawer();
          // });
          this.$message.success('操作成功！');
          this.fileList = [];
          this.form2.appealRemark = '';
          this.cancelForm()
          this.flushed()
        } else {
          this.$message.error('操作失败，请稍后重试');
        }
      } catch (error) {
        console.error(error);
        this.$message.error('系统错误，请稍后重试');
      } finally {
        this.loading = false;
      }
    },


    // // 重置
    // resetEvent() {
    //   this.formData = {
    //     feeType: '',
    //     name: ''
    //   }
    //
    //   this.requestParam.searchCount = false
    //   this.requestParam.current = 1
    //   this.requestParam.name = ''
    //   this.requestParam.feeType = ''
    //
    //   this.$refs.pager.reset()  // 重置分页器
    //   this.flushed()
    // },


    // 考核备注
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },


    // 操作
    handleCommand(command, row) {
      this.currentRow = row
      console.log(command, row, "command,b的值");
      if (command === 'a') { //提交
        //this.openEditDialog(row.id, 'submit')
        this.dialogMsg = '确定提交吗？'
        this.statName = '提交'
        this.dialogVisible = true
      } else if (command === 'b') { //审核
        //this.openEditDialog(row.id, 'check')
        this.dialogMsg = '确定审核吗？'
        this.statName = '审核'
        this.dialogVisible = true
      } else if (command === 'c') { //驳回
        //this.openEditDialog(row.id, 'reject')
        this.dialogMsg = '确定驳回吗？'
        this.statName = '驳回'
        this.dialogVisible = true
      } else if (command === 'd') { //取消
        //this.openEditDialog(row.id, 'cancel')
        this.dialogMsg = '确定取消吗？'
        this.statName = '取消'
        this.dialogVisible = true
      }else if(command === 'e') {//启动流程
        this.$mask.open();
        let processDefinitionId = "";
        const wfName = row.brandName && row.brandName === '百得' ? '百得' : '华帝';

        request({
          url: api.act.getProcessDefinitionsUrl,
          method: 'post',
          data: {tableKey: "WkVirtualBarcodeBill", wfName},
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if(response.data.data && response.data.data.length > 0) {
            processDefinitionId = response.data.data[0].id;
            console.log("赋值" + processDefinitionId);

            // 在这里发起第二个请求
            this.$http({
              url: api.act.startWfUrl,
              method: 'post',
              data: {
                id: row.id,
                tableKey: "WkVirtualBarcodeBill",
                orgId: row.orgId,
                orderNo: row.billNo,
                processDefinitionId: processDefinitionId
              },
              isLoading: true,
              modalStrictly: true,
            }).then(response => {
              this.$mask.close();
              if (response.data.type == "success") {
                this.$message({message: response.data.content, type: 'success'});
                this.loadTabOption();
                this.getTableData();
              } else {
                this.$message({message: response.data.content, type: 'warning'});
              }
            });
          }
        });
      } else if (command === 'f') { //查看流程
        this.actPicUrl = `/act/wf/wfview/` + row.processId
        this.showPicDialog = true
      }
      this.$mask.close()

    },


    handleCommand2(command, b) {
      if (b == 1) {
        this.showPreconditionDialog2 = true;
      } else if (b == 2) {
        this.open()
      }
    },

    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },

    gradeChange() {
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },

    // 新增
    openEditDialog(row, type) {
      this.type = type
      this.dataId = !row.id || typeof row.id == 'object' ? 0 : row.id;
      this.processId=row.processId
      console.log(row.processId,"row.processId");
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },

  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}
// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBtn {
  //白底按钮

  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}
.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}
.btnGoodsStatusBtn1 {
  //红底按钮

  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

//.el-drawer.ltr, .el-drawer.rtl {
//  height: 100%;
//  top: 0;
//  bottom: 0;
//  background-color: #cbcbcb;
//}
 .avue-view{
  height: 100%;

  overflow: scroll !important;;
}
</style>
